import { environmentCommon } from '../environments/environment.common';

export const environment = {
  ...environmentCommon,
  production: false, // TODO change after fixing camelCase in request headers
  loadTranslationFromServer: true,
  host: 'https://shop.ferrochema.at',

  api: {
    ...environmentCommon.api,
    host: 'https://shop.ferrochema.at',
    branchKey: 'W102',
  },

  cms: {
    ...environmentCommon.cms,
    host: 'http://10.87.100.103:6006',
  },

  sentry: {
    ...environmentCommon.sentry,
    dsn: 'https://ae01a6a44ac04d6481d960956bd06a91@o920539.ingest.sentry.io/6105512',
    active: true,
  },
  name: 'PRODUCTION',
  labelPrint: {
    logoPath: '/assets/images/logo_W102.png',
  },
};
